// extracted by mini-css-extract-plugin
export default {"AppHistoryCard":"AppHistory_AppHistoryCard__dxJ-5"};